import { Modal, Text } from "@bigcommerce/big-design";
import { useCallback } from "react";

export type DeleteFacetConfigurationProps = {
  isOpen: boolean,
  configurationToDeleteId: string,
  handleClose: () => void,
  handleResetFacetConfigurations: () => void,
};

export const DeleteFacetConfiguration = (props: DeleteFacetConfigurationProps): JSX.Element => {
  const handleDeleteCancel = useCallback(() => {
    props.handleClose();
  }, [props]);

  const handleDeleteConfirmation = useCallback(async () => {
    try {
      await fetch(`/api/facet-configuration/${props.configurationToDeleteId}`, {
        method: 'delete'
      });
      await fetch("/api/debug/publishScripts", {
        method: "post"
      });
      handleDeleteCancel();
      props.handleResetFacetConfigurations();
    } finally { }
  }, [props, handleDeleteCancel]);

  return <>
    <Modal
      actions={[
        { text: 'Cancel', variant: 'subtle', onClick: handleDeleteCancel },
        { text: 'Delete', onClick: handleDeleteConfirmation },
      ]}
      header="Delete your Custom Facet Configuration"
      isOpen={props.isOpen}
      onClose={props.handleClose}
      closeOnEscKey={true}
      closeOnClickOutside={false}
    >
      <Text>
        Are you sure you want to delete the facet configuration?
      </Text>
    </Modal>
  </>
}
